module.exports = {
    css: {
      loaderOptions: {
        postcss: {
          plugins: [
            
            require('postcss-plugin-px2rem')({
             
              exclude: /(node_module)/, 
              
              mediaQuery: false, 
              minPixelValue: 3 
          }),
          ]
        }
      }
    },
  
    configureWebpack: () => {
    },
  };


//////////////////
// WEBPACK FOOTER
// ./vue.config.js
// module id = D/cJ
// module chunks = 99